import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminRoute } from './components/AdminRoute';
import Layout from './components/layout/Layout';
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import Dashboard from './pages/dashboard/Dashboard';
import Employees from './pages/employees/Employees';
import EmployeeDetails from './pages/employees/EmployeeDetails';
import Locations from './pages/locations/Locations';
import PayrollCompanies from './pages/payroll-companies/PayrollCompanies';
import Departments from './pages/departments/Departments';
import Templates from './pages/templates/Templates';
import TemplateCategories from './pages/templates/TemplateCategories';
import TaskTemplates from './pages/templates/TaskTemplates';
import Onboarding from './pages/onboarding/Onboarding';
import OnboardingRequestDetails from './pages/onboarding/OnboardingRequestDetails';
import EditOnboardingRequest from './pages/onboarding/EditOnboardingRequest';
import Offboarding from './pages/offboarding/Offboarding';
import OffboardingRequestDetails from './pages/offboarding/OffboardingRequestDetails';
// import Settings from './pages/Settings';  // Commented out for UAT
import Profile from './pages/Profile';
// import Notifications from './pages/Notifications';  // Commented out for UAT
import ApprovalReview from './pages/approvals/ApprovalReview';
import ItemApprovalReview from './pages/approvals/ItemApprovalReview';
import SystemUsers from './pages/system-users/SystemUsers';
import Teams from './pages/teams/Teams';
import Unauthorized from './pages/Unauthorized';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/approvals/review" element={<ApprovalReview />} />
          <Route path="/approvals/review-item" element={<ItemApprovalReview />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Protected Routes */}
          <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
          <Route path="/employees" element={<ProtectedRoute><Layout><Employees /></Layout></ProtectedRoute>} />
          <Route path="/employees/:id" element={<ProtectedRoute><Layout><EmployeeDetails /></Layout></ProtectedRoute>} />
          <Route path="/locations" element={<ProtectedRoute><Layout><Locations /></Layout></ProtectedRoute>} />
          <Route path="/payroll-companies" element={<ProtectedRoute><Layout><PayrollCompanies /></Layout></ProtectedRoute>} />
          <Route path="/departments" element={<ProtectedRoute><Layout><Departments /></Layout></ProtectedRoute>} />
          <Route path="/templates" element={<ProtectedRoute><Layout><Templates /></Layout></ProtectedRoute>} />
          <Route path="/template-categories" element={<ProtectedRoute><Layout><TemplateCategories /></Layout></ProtectedRoute>} />
          <Route path="/task-templates" element={<ProtectedRoute><Layout><TaskTemplates /></Layout></ProtectedRoute>} />
          <Route path="/onboarding" element={<ProtectedRoute><Layout><Onboarding /></Layout></ProtectedRoute>} />
          <Route path="/onboarding/:id" element={<ProtectedRoute><Layout><OnboardingRequestDetails /></Layout></ProtectedRoute>} />
          <Route path="/onboarding/:id/edit" element={<ProtectedRoute><Layout><EditOnboardingRequest /></Layout></ProtectedRoute>} />
          <Route path="/offboarding" element={<ProtectedRoute><Layout><Offboarding /></Layout></ProtectedRoute>} />
          <Route path="/offboarding/:id" element={<ProtectedRoute><Layout><OffboardingRequestDetails /></Layout></ProtectedRoute>} />
          {/* <Route path="/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} /> */}
          <Route path="/profile" element={<ProtectedRoute><Layout><Profile /></Layout></ProtectedRoute>} />
          {/* <Route path="/notifications" element={<ProtectedRoute><Layout><Notifications /></Layout></ProtectedRoute>} /> */}

          {/* Admin Only Routes */}
          <Route path="/system-users" element={<AdminRoute><Layout><SystemUsers /></Layout></AdminRoute>} />
          <Route path="/teams" element={<AdminRoute><Layout><Teams /></Layout></AdminRoute>} />
          </Routes>
          <Toaster
            closeButton
            position="top-right"
            expand={false}
            richColors
            duration={4000}
          />
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
